import { Flex, Stack, Text, useMediaQuery } from '@viveaesthetics/shared'
import Image from 'next/image'
import React from 'react'

import TherapistSearchIllustration from '@public/images/TherapistSearchIllustration.svg'
import { InsurancesEnum } from '@/types/providers'

interface ProviderInfoBlockProps {
  location?: string
  providerCount: number
  insurance?: InsurancesEnum | string
  insuranceId?: string
}

export const ProviderInfoBlock = ({
  providerCount,
  insurance,
  location
}: ProviderInfoBlockProps) => {
  const { isDesktop } = useMediaQuery()
  return (
    <Flex
      $space="spacing40"
      template={isDesktop ? ['none', 1] : []}
    >
      {isDesktop && (
        <Image
          alt="Search therapists illustration"
          src={TherapistSearchIllustration.src}
          width={150}
          height={104}
        />
      )}
      <Stack $space="spacing8">
        <Text
          type="labelMBold"
          as="h1"
        >
          {providerCount} providers in {location || 'state'} matching your needs
        </Text>
        <Text
          type="textS"
          $color="textSecondary"
          wordBreak="break-word"
          as="h2"
        >
          Take advantage of your{' '}
          {insurance && insurance !== InsurancesEnum.CASH ? insurance : ''}{' '}
          insurance plan. Schedule an appointment with a qualified and trusted{' '}
          {location} therapist that&apos;s in-network with your insurance
          provider. Browse different certified mental health providers below.
        </Text>
      </Stack>
    </Flex>
  )
}
